import { render, staticRenderFns } from "./traducao_completa_force.vue?vue&type=template&id=0a170a1e"
import script from "./traducao_completa_force.vue?vue&type=script&lang=js"
export * from "./traducao_completa_force.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports